import {
    React, RouteComponentProps,
    Formsy, form, formHelpers,
    i18n,
    observable, inject, observer,
    mui, ui, theme, pr,
    debug
} from "aaa";
import { User } from "models/User";
import { AnimDiv } from "@aaa/animdiv";
import * as _ from "lodash";

export const IncomeSecondBorrower = (props: { user: User }) => {
    return <form.FormsyText
        name="incomeNetSecondBorrower"
        required={true}
        validations="isPositiveCurrency"
        floatingLabelText={ui.__("income.net.secondBorrower") + props.user.secondBorrowerName}
        fullWidth={true}
        value={props.user.secondBorrowerNetIncome.toStringShort()}
        validationError={ui.__("error.currencyInvalid")}
    />;
};


type IProps = i18n.InjectedIntlProps & {
    user: User,
    isSummary?: boolean
};

@i18n.injectIntl
@inject("user")
@observer
export class IncomeContent extends React.Component<IProps, {}> {

    @observable
    otherDescriptionVisible = this.props.user.income.other.value > 0;

    render() {
        return (
            <div>
                <form.FormsyText
                    name="incomeNet"
                    required={true}
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("income.net")}
                    fullWidth={true}
                    value={this.props.user.income.net.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                />

                {
                    this.props.user.hasSecondBorrower &&
                    this.props.isSummary !== true &&
                    <IncomeSecondBorrower user={this.props.user} />
                }

                <form.FormsyText
                    name="incomeChildMoney"
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("income.childMoney")}
                    fullWidth={true}
                    value={this.props.user.income.childMoney.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                />

                <form.FormsyText
                    name="incomeRent"
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("income.rent")}
                    floatingLabelStyle={{ marginTop: ui.isMobile ? -20 : 0 }}
                    fullWidth={true}
                    value={this.props.user.income.rent.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                />

                <form.FormsyText
                    name="incomeOther"
                    validations="isPositiveCurrency"
                    floatingLabelText={ui.__("income.other")}
                    fullWidth={true}
                    value={this.props.user.income.other.toStringShort()}
                    validationError={ui.__("error.currencyInvalid")}
                    onChange={(e: any, value: string) => { this.otherDescriptionVisible = value.length > 0 && Number(value) > 0; }}
                />

                <AnimDiv>{this.otherDescriptionVisible && <form.FormsyText
                    name="incomeOtherDescription"
                    validations="minLength:1"
                    required={true}
                    floatingLabelText={ui.__("income.otherDescription")}
                    fullWidth={true}
                    value={this.props.user.income.otherDescription}
                    validationError={ui.__("error.requiredField")}
                />}</AnimDiv>
            </div>
        );
    }
}



@i18n.injectIntl
@inject("user")
@observer
export class IncomeForm extends React.Component<RouteComponentProps<{}> & IProps & { onSubmit: (keysSubmittedFields: string[]) => void }, {}> {

    @observable
    formIsValid = false;

    private formRef: any;

    static parseInput(user: User, fields: any) {
        const income = user.income;

        if (user.hasSecondBorrower) {
            user.secondBorrowerNetIncome.fromString(fields.incomeNetSecondBorrower);
        }

        income.net.fromString(fields.incomeNet);
        income.childMoney.fromString(fields.incomeChildMoney);
        income.rent.fromString(fields.incomeRent);
        income.other.fromString(fields.incomeOther);
        income.otherDescription = fields.incomeOtherDescription;
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        // SUCCESS-REDIRECT: user has already fully submitted previously, hard redirect to /loan
        if (this.props.user.successfullySubmitted === true) {
            window.location.replace(window.location.origin + window.location.pathname); // we wont include hash - root page only.
        }
    }

    onSubmit = (fields: any, resetForm: any, invalidateForm: any) => {
        IncomeForm.parseInput(this.props.user, fields);
        debug.log("### Income", this.props.user.income);

        const submittedFields = _.compact(_.map(fields as _.Dictionary<any>, (value, key) => {
            return _.isNil(value) ? null : key;
        }));

        this.props.onSubmit(submittedFields);

        this.props.history.push("/expenses");
    }

    render() {
        return (
            <pr.FormContainer>
                <Formsy.Form
                    onInvalidSubmit={(fields: any, reset: any, invalidate: any) => formHelpers.invalidateRequiredFields(this.formRef, invalidate)}
                    onValidSubmit={this.onSubmit}
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                    noValidate
                    ref={(c: any) => this.formRef = c}
                >
                    <IncomeContent user={this.props.user} />
                    {formHelpers.renderActionButton(ui.__("continue"))}
                </Formsy.Form>
            </pr.FormContainer >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/IncomeForm.tsx